import api from "./api";

export default class HubspotAPI {
    postSaveDomainKey(formData) {
        return api.post("hubspot/save-domain-id", formData);
    }
}
